"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _table = require("./table.style");

var _Checkbox = require("../Checkbox/Checkbox");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TableRow = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      select = _useState2[0],
      setSelect = _useState2[1];

  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _table.useStyles)(props);
  var itemRef = (0, _react.useRef)();

  var handleSelectItem = function handleSelectItem(e, obj) {
    if (select && props.handleSelectAll) props.handleUnselectAll();
    setSelect(!select);
    props.onItemSelect(e, obj);
  };

  (0, _react.useEffect)(function () {
    setSelect(props.handleSelectAll);
  }, [props.handleSelectAll]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "".concat(classes.tableRow, " ").concat(props.item["default"] ? classes.listSelected : null),
    ref: itemRef,
    role: "gridcell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.li),
    onClick: function onClick() {
      var parent = itemRef.current.parentNode;

      for (var i = 0; i < parent.children.length; i++) {
        parent.children[i].classList.remove(classes.listSelected);
      }

      itemRef.current.classList.add(classes.listSelected);
      props.onChange(props.item);
    }
  }, props.multiple && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.col)
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    size: 'sm',
    onChange: function onChange(e) {
      return handleSelectItem(e.target.checked, props.item);
    },
    checked: select
  })), props.headers.map(function (header, headerIndex) {
    return props.item[header.rowName] === "" ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.col),
      key: headerIndex
    }, "-") : props.item[header.rowName] && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.col),
      key: headerIndex
    }, props.item[header.rowName]);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.action)
  }, props.headers.map(function (header, headerIndex) {
    return props.item.actions && props.item.actions[header.rowName] && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classes.col),
      key: headerIndex
    }, props.item.actions[header.rowName]);
  })));
});

var _default = TableRow;
exports["default"] = _default;